'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CustomerTag = function CustomerTag(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", null), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: "M23.295,11.466L12.522,0.694C12.091,0.263,11.493,0,10.834,0H2.457C1.14,0,0.062,1.077,0.062,2.394v8.378\n\t\tc0,0.658,0.264,1.256,0.706,1.699l10.772,10.772c0.431,0.431,1.03,0.694,1.687,0.694c0.659,0,1.257-0.264,1.688-0.705l8.379-8.379\n\t\tC23.735,14.422,24,13.824,24,13.166S23.724,11.897,23.295,11.466z M11.456,17.107c-3.326,0-6.02-2.699-6.02-6.026\n\t\tc0-3.326,2.694-6.025,6.02-6.025c3.331,0,6.033,2.7,6.033,6.025C17.488,14.408,14.786,17.107,11.456,17.107z"
  }), React__default["default"].createElement("circle", {
    cx: "13.569",
    cy: "9.575",
    r: "0.904"
  }), React__default["default"].createElement("circle", {
    cx: "9.353",
    cy: "9.575",
    r: "0.904"
  }), React__default["default"].createElement("path", {
    d: "M13.569,8.671c0.502,0,0.904,0.404,0.904,0.904s-0.402,0.904-0.904,0.904c-0.499,0-0.903-0.404-0.903-0.904\n\t\tS13.07,8.671,13.569,8.671z M9.353,8.671c0.5,0,0.903,0.404,0.903,0.904s-0.403,0.904-0.903,0.904c-0.5,0-0.904-0.404-0.904-0.904\n\t\tS8.853,8.671,9.353,8.671z M11.461,14.394c-1.403,0-2.596-0.877-3.079-2.107h6.158C14.061,13.517,12.865,14.394,11.461,14.394z"
  }), React__default["default"].createElement("path", {
    d: "M11.461,14.394c1.404,0,2.6-0.877,3.079-2.107H8.382C8.865,13.517,10.058,14.394,11.461,14.394z"
  })));
};

var CustomerTag$1 = iconStyles()(CustomerTag);

module.exports = CustomerTag$1;
